import React from "react";
import { Search } from "lucide-react";
import { Input } from "../ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../ui/select";

export function CustomerFilters({
  search, setSearch,
  kycFilter, setKycFilter,
  riskFilter, setRiskFilter,
  personTypeFilter, setPersonTypeFilter,
  stateFilter, setStateFilter,
  setPage,
}) {
  const onChange = (setter) => (v) => {
    setter(v);
    setPage(1);
  };

  return (
    <div className="flex flex-wrap gap-3 mb-6" data-testid="customer-filters">
      <div className="relative flex-1 min-w-[200px]">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
        <Input
          placeholder="Buscar por nombre, RFC, email..."
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1); }}
          className="pl-9 bg-slate-900 border-slate-700 text-white placeholder:text-slate-500"
          data-testid="customer-search-input"
        />
      </div>
      <Select value={kycFilter} onValueChange={onChange(setKycFilter)}>
        <SelectTrigger className="w-[160px] bg-slate-900 border-slate-700 text-slate-300" data-testid="kyc-filter">
          <SelectValue placeholder="KYC Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos KYC</SelectItem>
          <SelectItem value="pending">Pendiente</SelectItem>
          <SelectItem value="verified">Verificado</SelectItem>
          <SelectItem value="rejected">Rechazado</SelectItem>
        </SelectContent>
      </Select>
      <Select value={riskFilter} onValueChange={onChange(setRiskFilter)}>
        <SelectTrigger className="w-[160px] bg-slate-900 border-slate-700 text-slate-300" data-testid="risk-filter">
          <SelectValue placeholder="Riesgo" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos Riesgos</SelectItem>
          <SelectItem value="low">Bajo</SelectItem>
          <SelectItem value="medium">Medio</SelectItem>
          <SelectItem value="high">Alto</SelectItem>
          <SelectItem value="critical">Critico</SelectItem>
        </SelectContent>
      </Select>
      <Select value={personTypeFilter} onValueChange={onChange(setPersonTypeFilter)}>
        <SelectTrigger className="w-[170px] bg-slate-900 border-slate-700 text-slate-300" data-testid="person-type-filter">
          <SelectValue placeholder="Tipo persona" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos los tipos</SelectItem>
          <SelectItem value="fisica">Persona física</SelectItem>
          <SelectItem value="moral">Persona moral</SelectItem>
        </SelectContent>
      </Select>
      <Select value={stateFilter} onValueChange={onChange(setStateFilter)}>
        <SelectTrigger className="w-[170px] bg-slate-900 border-slate-700 text-slate-300" data-testid="state-filter">
          <SelectValue placeholder="Estado cliente" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Activos + borradores</SelectItem>
          <SelectItem value="active">Solo activos</SelectItem>
          <SelectItem value="draft">Solo borradores</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
